import React from 'react';

import { Pill } from '@/components';
import { SwitchField } from '@/components/form/SwitchField';
import { DataDef, DataDefProps, FilterType } from '../types';

export const renderBooleanValue = (value: boolean) => (value ? '✅' : '❌');

export const booleanFilter = ({
  field,
  filterField,
  title,
}: {
  field: string;
  filterField: string;
  title: string;
}): FilterType => ({
  field,
  transformDefaultValues: (values) => {
    const value = values[filterField];
    return {
      ...values,
      [filterField]: typeof value === 'boolean' ? value : undefined,
    };
  },
  transformValues: (values) => {
    const value = values[filterField];
    return { ...values, [filterField]: value ?? undefined };
  },
  component: () => (
    <SwitchField
      name={filterField}
      id={filterField}
      title={title}
      labelPlacement="above"
      allowUndefinedState={false}
    />
  ),
  pillView: (values, updateFilter) => {
    const value = values[filterField];
    if (typeof value === 'boolean') {
      return (
        <Pill onClick={() => updateFilter({ [filterField]: undefined })}>
          {renderBooleanValue(value)}
        </Pill>
      );
    }
    return null;
  },
});

export function booleanValue<O, T extends Record<string, any>>({
  title,
  field,
  getValue,
  filterField,
  ...rest
}: DataDefProps<O, T> & {
  filterField?: string;
}): DataDef<O, T> {
  return {
    title,
    field,
    ...rest,
    component: ({ row }) => {
      const value = getValue ? getValue({ row }) : row[field];
      return <>{renderBooleanValue(value)}</>;
    },
    filter: filterField
      ? booleanFilter({ field, title, filterField })
      : undefined,
  };
}
